import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class ModuleScriptTypeApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'moduleScriptType';
    }

}